import { PageContextUtils, UrlUtils } from "../../../../utils";

import { config as defaultConfig } from "../../default/Spectate/Config.resource";

const getSportUrl = () => {
  return UrlUtils.getCurrentOriginURLWithLang(window.location.origin);
};

const { clientPage } = PageContextUtils.getSurveyData();

export const links = {
  betFeed: "/betfeed/",
  bettingHistory: "/bets/b/",
  bettingRules: "/getting-started/betting-rules/",
  blog: "/blog/",
  contactUs: `https://888-external-en.custhelp.com/app/home/p/243/`,
  downloadApp: "/mrgreen-apps-ios-android/",
  help: "http://www.888.com/help/app/home/p/243/",
  home: "/",
  liveChat:
    "https://888-external-en.custhelp.com/app/chat/chat_launch?chanel=888sport_en_norm&ChRefId=3",
  liveChatVIP:
    "https://888-external-en.custhelp.com/app/chat/chat_launch?chanel=888sport_en_vip&ChRefId=1",
  liveNow: {
    de: "/live-wetten/",
    en: "/live-betting/",
    es: "/apuestas-en-vivo/",
    fr: "/paris-en-direct/"
  },
  pokerHistoryLink: "/app/poker-history/",
  promotions: "/promotions",
  recommendations: "/not-defined/",
  madeForYou: {
    ar: "/madeforyou/fortoday/mfytoday/",
    deu: "/fursiegemacht/furheute/mfytoday/",
    en: "/madeforyou/fortoday/mfytoday/",
    es: "/disenadoparati/parahoy/mfytoday/",
    fi: "/sinuavarten/tallepaivalle/mfytoday/",
    fr: "/concupourvous/pouraujourdhui/mfytoday/",
    pt: "/feitoparavoce/parahoje/mfytoday/",
    ru: "/сделанодлявас/Насегодня/mfytoday/"
  },
  responsibleGaming: "https://greengaming.com/",
  responsibleGamingExternal: "https://greengaming.com/",
  sportUrl: getSportUrl(),
  pokerUrl: "https://www.mrgreen.com/poker/",
  startingSoon: "/starting-soon/",
  survey: clientPage,
  casinoUrl: "https://www.mrgreen.com/",
  casinoNativeUrl: "",
  pokerNativeUrl: ""
};

export const config = {
  ...defaultConfig,
  logo: "logo-mrg",
  logoMobile: "logo-mrg-mobile",
  logoAlt: ""
};
